export class Stock {
  id: number;
  pallet_id: number;
  tag_id: number;
  stock_status_id: number;
  location_id: number;
  position_id: number;

  constructor(id, pallet, tag, status, locationid, positionid) {
    this.id = id;
    this.pallet_id = pallet;
    this.tag_id = tag;
    this.stock_status_id = status;
    this.location_id = locationid;
    this.position_id = positionid;
  }


  public getJson() {
    let nul1 = '';
    let nul2 = '';
    let nul3 = '';
    if (this.id != null) {
      nul1 = `"id": "${this.id}",`;
    }
    if (this.pallet_id != null) {
      nul2 = `"pallet_id": "${this.pallet_id}",`;
    }
    if (this.position_id != null) {
      nul3 = `"position_id": "${this.position_id}",`;
    }

    return `{
      "data":{
        "type": "stock",
        `+ nul1 + `
        "attributes": {
          `+ nul1 + `
          `+ nul2 + `
          "tag_id": "${this.tag_id}",
          "stock_status_id": "${this.stock_status_id}",
          `+ nul3 + `
          "location_id": "${this.location_id}"
        }
      }
    }`;
  }

  public getJson2() {
    let nul1 = '';
    let nul3 = '';

    if (this.id != null) {
      nul1 = `"id": "${this.id}",`;
    }
    if (this.position_id != null) {
      nul3 = `"position_id": "${this.position_id}",`;
    }

    return `{
      "data":{
        "type": "stock",
        `+ nul1 + `
        "attributes": {
          `+ nul1 + `
          "pallet_id": null,
          "tag_id": "${this.tag_id}",
          "stock_status_id": "${this.stock_status_id}",
          `+ nul3 + `
          "location_id": "${this.location_id}"
        }
      }
    }`;
  }

  public getJson3(obs) {
    let nul1 = '';
    let nul3 = '';

    if (this.id != null) {
      nul1 = `"id": "${this.id}",`;
    }

    if (obs != null) {
      nul3 = `"observations": "${obs}",`;
    }

    return `{
      "data":{
        "type": "stock",
        `+ nul1 + `
        "attributes": {
          `+ nul1 + `
          "pallet_id": "${this.pallet_id}",
          "tag_id": "${this.tag_id}",
          "stock_status_id": "${this.stock_status_id}",
          `+ nul3 + `
          "position_id": "${this.position_id}"
        }
      }
    }`;
  }
  /**
   * Crea el formato JSON para el envio a través de HTTP de todos los packing como un arreglo
   * @return JSON a enviar.
   */
   public getJson4(pallet){
     let coma =',';
     let esp = '';
     for(let i=0;i < pallet.boxes.length;i++){
       if((i+1) === pallet.boxes.length){
         coma = '';
       }
       esp += `{"type":"stock","reason_id":"${pallet.boxes[i].relationships.packing.data.attributes.packing_type_id}","position_id":"${pallet.positionid}","pallet_id":"${pallet.id}","tag_id":"${pallet.boxes[i].id}","stock_status_id":"1"}${coma}`;
     }

     return `{"data":[${esp}]}`;
   }
   /**
    * Crea el formato JSON para el movimiento a través de HTTP de todos las cajas como un arreglo
    * @return JSON a enviar.
    */
    public getJson5(pallet,posicionesvacias){
      let coma =',';
      let esp = '';
      let pos = 0;
      let nul1 = '';

      for(let caja of pallet){
        pos +=1;
        if(pos === pallet.length){
          coma = '';
        }

        if (caja.value.guia != '' || caja.value.guia != null || caja.value.guia != ' ') {
          nul1 = `,"guide": "${caja.value.guia}"`;
        }

        /*Caja que va a una ubicacion sin pallet*/
        if(isNaN(caja.value.idpallet) && isNaN(caja.value.idposicion)){
          esp += `{"type":"stock","position_id":"${posicionesvacias.find(o => o.idubicacion == caja.value.idubicacion).idposicion}","pallet_id":null,"id":"${caja.value.id}"`+ nul1 + `}${coma}`;
        }
        else if(isNaN(caja.value.idpallet) && !(isNaN(caja.value.idposicion))){
          console.log('error');
        }
        else if(!(isNaN(caja.value.idpallet)) && isNaN(caja.value.idposicion)){
          console.log('error');
        }/*Caja que va a una ubicación con pallet*/
        else if(!(isNaN(caja.value.idpallet)) && !(isNaN(caja.value.idposicion))){
          esp += `{"type":"stock","position_id":"${caja.value.idposicion}","pallet_id":"${caja.value.idpallet}","id":"${caja.value.id}"`+ nul1 + `}${coma}`;
        }
      }

      return `{"data":[${esp}]}`;
    }

    /**
     * Crea el formato JSON para el movimiento a través de HTTP de todos las cajas como un arreglo
     * @return JSON a enviar.
     */
     public getJson6(cajas,pallet){
       let coma =',';
       let esp = '';
       let pos = 0;
       let nul1 = '';

       if (pallet.value.guia != '' || pallet.value.guia != ' ' || pallet.value.guia != null) {
         nul1 = `,"guide": "${pallet.value.guia}"`;
       }

       for(let caja of cajas){
         pos +=1;
         if(pos === cajas.length){
           coma = '';
         }

         esp += `{"type":"stock","position_id":"${pallet.value.idposicion}","pallet_id":"${pallet.value.id}","id":"${caja.id}"`+ nul1 + `}${coma}`;
       }
       return `{"data":[${esp}]}`;
     }

     /**
      * Crea el formato JSON para el movimiento a través de HTTP de todos las cajas como un arreglo
      * @return JSON a enviar.
      */
      public getJson7(cajas,reason,guide,cliente){
        //console.log('cliente recibido',cliente);
        let razon = parseInt(reason);
        let guia = -1;
        let coma =',';
        let esp = '';
        let pos = 0;
        if(guide != null){
          guia = parseInt(guide);
        }
        for(let caja of cajas){
          pos +=1;
          if(pos === cajas.length){
            coma = '';
          }
          esp+=`{"type":"stock","exit_reason_id":"${razon}"`;
          guia!=-1?esp+=`,"guide":"${guia}"`:`,`;
          cliente!=null?esp+=`,"client":"${cliente}"`:`,`;
          esp+=`,"id":"${caja.id}"}${coma}`;
        }

        // if(guide != null){
        //   guia = parseInt(guide);
        //
        //   for(let caja of cajas){
        //     pos +=1;
        //     if(pos === cajas.length){
        //       coma = '';
        //     }
        //     esp += `{"type":"stock","exit_reason_id":${razon},"guide":${guia},"id":${caja.id}}${coma}`;
        //   }
        // }
        // else{
        //   for(let caja of cajas){
        //     pos +=1;
        //     if(pos === cajas.length){
        //       coma = '';
        //     }
        //     esp += `{"type":"stock","exit_reason_id":${razon},"id":${caja.id}}${coma}`;
        //   }
        // }
        return `{"data":[${esp}]}`;
      }

      /**
       * Crea el formato JSON para el movimiento a través de HTTP de todos las cajas como un arreglo
       * @return JSON a enviar.
       */
       public getJsonOrdenSalidaStock(cajas,reason){
         let razon = parseInt(reason);
         let coma =',';
         let esp = '';
         let pos = 0;

         for(let caja of cajas){
           pos +=1;
           if(pos === cajas.length){
             coma = '';
           }
           esp += `{"type":"stock","exit_reason_id":${razon},"id":${caja.id}}${coma}`;
         }

         return `{"data":[${esp}]}`;
       }


      public getJson8(pallets,cliente){
        let coma =',';
        let esp = '';

        for(let i=0;i < pallets.length;i++){
          if((i+1) === pallets.length){
            coma = '';
          }
          esp+=`{"id":"${pallets[i].id}"`;
          pallets[i].guia != "No Corresponde"?esp+=`,"guide":"${pallets[i].guia}",`:esp+=`,`;
          esp+=`"exit_reason_id":"${pallets[i].razon}"`;

          // esp+=`{"id":"${pallets[i].id}","guide":"${pallets[i].guia}","exit_reason_id":"${pallets[i].razon}"`;
          cliente!=null?esp+=`,"client":"${cliente}"}${coma}`:esp+=`}${coma}`;

          //original
          // esp += `{"id":"${pallets[i].id}","guide":"${pallets[i].guia}","exit_reason_id":"${pallets[i].razon}"}${coma}`;
        }

        return `{"data":[${esp}]}`;
      }

      public getJsonDevolucion(cajas:any[]){

        let coma = ',';
        let body = `{ "data":[`;
        let pos = 0;
        for(let caja of cajas){
          if((pos+1) === cajas.length){
            coma = '';
          }
          body+=`{
            "id":"${caja.stock_id}",
            "tag_id":"${caja.tag_id}",
            "pallet_id" : "${caja.pallet_id}",
            "position_id": "${caja.position_id}",
            "stock_status_id" : "${caja.stock_status_id}",
            "reason_id":"${caja.reason_id}"
                 }${coma}`;
          pos++;
        }
        body+=`]}`;
        //console.log("BODY PETICION STOCKS DEVOLUCION: ", body);
        return body;
      }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/model/Stock.ts